import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';

// PRIME NG
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {CheckboxModule} from 'primeng/checkbox';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import {DialogService, DynamicDialogModule} from 'primeng/dynamicdialog';
import {DropdownModule} from 'primeng/dropdown';
import {FieldsetModule} from 'primeng/fieldset';
import {FileUploadModule} from 'primeng/fileupload';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {MessageModule} from 'primeng/message';
import {MessagesModule} from 'primeng/messages';
import {PickListModule} from 'primeng/picklist';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {RadioButtonModule} from 'primeng/radiobutton';
import {RippleModule} from 'primeng/ripple';
import {TabViewModule} from 'primeng/tabview';
import {TableModule} from 'primeng/table';
import {ToolbarModule} from 'primeng/toolbar';
import {TooltipModule} from 'primeng/tooltip';

// other
import {MatFormFieldModule} from '@angular/material/form-field';

// ACABIM
import {AcabimCommonModule, AcabimAuthGuardService} from '@cas-hub/acabim-common-client';
import {AcabimUserLayoutComponent} from './acabim-user-layout.component';
import { AddDataComponent } from './pages/profile/add-data-modal/add-data.component';
import { DeleteDataComponent } from './pages/profile/delete-data-modal/delete-data.component';
import {OrganisationComponent} from './pages/organisation/organisation.component';
import {PasswordComponent} from './pages/password/password.component';
import {PrivacyComponent} from './pages/privacy/privacy.component';
import {ProfileComponent} from './pages/profile/profile.component';
import {RedirectAdminComponent} from './_components/redirect-admin.component';
import {ToastModule} from 'primeng/toast';
import { SharedResourcesComponent } from './pages/shared-resources/shared-resources.component';

@NgModule({
    declarations: [
        AcabimUserLayoutComponent,
        AddDataComponent,
        DeleteDataComponent,
        OrganisationComponent,
        PasswordComponent,
        PrivacyComponent,
        ProfileComponent,
        RedirectAdminComponent,
        SharedResourcesComponent,
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        FormsModule,
        AcabimCommonModule.forRoot({navigation: {items: new AcabimUserLayoutComponent().navItems}}),
        BreadcrumbModule,
        ButtonModule,
        CardModule,
        CheckboxModule,
        ConfirmDialogModule,
        DialogModule,
        DynamicDialogModule,
        DropdownModule,
        FieldsetModule,
        FileUploadModule,
        InputTextModule,
        InputTextareaModule,
        MessageModule,
        MessagesModule,
        PickListModule,
        ProgressSpinnerModule,
        RadioButtonModule,
        RippleModule,
        TabViewModule,
        TableModule,
        ToolbarModule,
        TooltipModule,
        RouterModule.forChild([
            {
                path: '', canActivate: [AcabimAuthGuardService], component: AcabimUserLayoutComponent, children: [
                    {path: '', redirectTo: 'profile', pathMatch: 'full'},
                    {path: 'profile', component: ProfileComponent},
                    {path: 'password', component: PasswordComponent},
                    {path: 'privacy', component: PrivacyComponent},
                    {path: 'shared-resources', component: SharedResourcesComponent},
                    {path: 'organisation', component: OrganisationComponent},
                    {path: 'administration', component: RedirectAdminComponent}
                ]
            }
        ]),
        MatFormFieldModule,
        ToastModule
    ],
    exports: [],
    providers: [DialogService],
    bootstrap: [AcabimUserLayoutComponent]
})

export class AcabimUserModule {}
